import React from "react";

import { connect } from "react-redux";
import { useEffect } from "react";
import { GET_BALANCE } from "../../redux/Getbalance/types";
import { useDispatch, useSelector } from "react-redux";
import "../HeaderComponent/Header.css";

import Getbalanceload from "../Getbalanceapimenu/Getbalanceload";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { NavLink } from "react-router-dom";
import axiosinstances from "../../Helper/useAxios";
import { isSuperAdmin, isUserAdmin } from "../../utils/comman/Common";

const Menu = () => {
  const [axiosInstance] = axiosinstances();
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const profiledataid = useSelector(
    (state) => state.getprofilereducer?.getprofile
  );
  //console.log('profiledataid',profiledataid)
  const [selectedRetailer, setSelectedRetailer] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useLocation();

  const e = JSON.parse(sessionStorage.getItem("token"));
  const fetchpagedata = async (pageindex) => {
    const response = await axiosInstance
      .get(`/api/v1/retailer/list/${pageindex}`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        //console.log("res-->", res);
        return res;
      })
      .catch((err) => {
        //console.log(err);
        // toast.error("Something went wrong");
      });

    if (response) {
      const result = response.data.list;

      if (result) {
      }

      return response.data;
    }
    return false;
  };
  // useEffect(() => {
  //   fetchpagedata(0)
  // }, []);

  const searchapidata = async (search) => {
    const response = await axiosInstance
      .get(`/api/v1/retailer/search/${search}`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        //console.log(err);
        // toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const taloadredirect = () => {
    navigate("/taload");
  };

  const getbalanceicon = () => {
    dispatch({ type: GET_BALANCE, id: id });
  };
  // useEffect(() => {
  //   if (id !== undefined) {
  //     getbalanceicon();
  //   }
  // }, [id]);
  const toHistory = () => {
    navigate(`/account-history/${id}`);
  };
  // <form>
  //        {/* <label for="browser">Choose your browser from the list:</label> */}
  //   <input list="browsers" name="browser" id="browser" placeholder="Select Retailer" onChange={selectRetailer} />
  //   <datalist id="browsers">
  //   <option value="Edge"/>
  //   <option value="Firefox"/>
  //   <option value="Chrome"/>
  //   <option value="Opera"/>
  //   <option value="Safari"/>
  //   </datalist>
  // {/* <input type="submit"/> */}
  //       </form>
  return (
    <div class="menu">
      <nav
        style={{ padding: 0, margin: 0 }}
        class="navbar navbar-expand-lg navbar-dark bg-dark"
      >
        {/* <a class="navbar-brand" href="#">Navbar</a> */}
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            {isUserAdmin(id) && (
              <li class="nav-item active">
                <NavLink
                  to="/retailer-list"
                  class={params.pathname === "/retailer-list" && "active"}
                >
                  <i class="recharge"></i> <span>Retailer List</span>
                </NavLink>
              </li>
            )}
            <li class="nav-item active">
              <NavLink
                to="/mobile-recharge"
                class={params.pathname === "/mobile-recharge" && "active"}
              >
                <i class="recharge"></i> <span>Mobile Recharge</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/bill-payment"
                class={params.pathname === "/bill-payment" && "active"}
              >
                <i class="bill"></i>
                <span>Bill Payment</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/dth-recharge"
                class={params.pathname === "/dth-recharge" && "active"}
              >
                <i class="dth"></i> <span>DTH Recharge</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/ott-recharge"
                class={params.pathname === "/ott-recharge" && "active"}
              >
                <i class="ott"></i> <span>OTT Recharge</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/money-transfer"
                class={params.pathname === "/money-transfer" && "active"}
              >
                <i class="dmt"></i> <span>Money Transfer</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/aeps-dashboard"
                class={params.pathname === "/aeps-dashboard" && "active"}
              >
                <i class="dmt"></i> <span>AEPS</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/payout-dashboard"
                class={params.pathname === "/payout-dashboard" && "active"}
              >
                <i class="dmt"></i> <span>Payout</span>
              </NavLink>
            </li>

            <li class="nav-item active">
              <NavLink
                to="/ticket-list"
                class={params.pathname === "/ticket-list" && "active"}
              >
                <i class="bill"></i> <span>Tickets</span>
              </NavLink>
            </li>
          </ul>
          <div
            className="tamnt d-flex justify-content-between"
            style={isUserAdmin(id) ? { width: "250px" } : { width: "350px" }}
            onClick={getbalanceicon}
          >
            {id !== undefined && <Getbalanceload id={id} />}
            <div>
              {!(isSuperAdmin(id) || isUserAdmin(id)) && (
                <button
                  type="button"
                  className="btn dbbtn ms-1 "
                  onClick={(e) => {
                    e.preventDefault();
                    taloadredirect(e);
                  }}
                >
                  Claim
                </button>
              )}
              {
                // !isUserAdmin(id) &&
                <button type="button" className="btn dbbtn" onClick={toHistory}>
                  History
                </button>
              }
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Menu;

{
  /* <div class="menu">
      <ul>
        { isUserAdmin(id) &&
           <li >
           <NavLink
             to="/retailer-list"
             class={params.pathname === "/retailer-list" && "active"}
           >
             <i class="recharge"></i> <span>Retailer List</span>
           </NavLink>
         </li>
        }
        <li>
          <NavLink
            to="/mobile-recharge"
            class={params.pathname === "/mobile-recharge" && "active"}
          >
            <i class="recharge"></i> <span>Mobile Recharge</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/bill-payment"
            class={params.pathname === "/bill-payment" && "active"}
          >
            <i class="bill"></i>
            <span>Bill Payment</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dth-recharge"
            class={params.pathname === "/dth-recharge" && "active"}
          >
            <i class="dth"></i> <span>DTH Recharge</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/ott-recharge"
            class={params.pathname === "/ott-recharge" && "active"}
          >
            <i class="ott"></i> <span>OTT Recharge</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/money-transfer"
            class={params.pathname === "/money-transfer" && "active"}
          >
            <i class="dmt"></i> <span>Money Transfer</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/aeps-dashboard"
            class={params.pathname === "/aeps-dashboard" && "active"}
          >
            <i class="dmt"></i> <span>AEPS</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/payout-dashboard"
            class={params.pathname === "/payout-dashboard" && "active"}
          >
            <i class="dmt"></i> <span>Payout</span>
          </NavLink>
        </li>
        
        {/* <li><a href="dmt.html"><i class="dmt"></i> <span>Money Transfer</span></a></li> */
}
//  </ul>
//       {

//       <div className="tamnt d-flex justify-content-between" style={ isUserAdmin(id) ? {width:'250px'} : {width:'350px'} }  onClick={getbalanceicon}>
//         {id !== undefined && <Getbalanceload id={id} />}
//         <div >
//           {  !(isSuperAdmin(id) || isUserAdmin(id)) &&
//         <button
//           type="button"
//           className="btn dbbtn ms-1 "
//           onClick={(e) => {
//             e.preventDefault();
//             taloadredirect(e);
//           }}
//         >
//           Claim
//         </button>
//       }
//         {
//           // !isUserAdmin(id) &&
//           <button
//           type="button"
//           className="btn dbbtn"
//           onClick={toHistory}
//         >
//           History
//         </button>

//         }
//        </div>
//       </div>
// }
//  </div> */}
